import t from "react";
import { useTranslation as k } from "react-i18next";
import { TicketServiceType as r } from "../../../../../../common/shared/ticketServiceType.js";
import { useKioskLanding as d } from "../../context.js";
import i from "./kioskService.module.scss.js";
function A({
  type: a
}) {
  const { configuration: e, lang: m } = d(), { t: c } = k(), n = a === r.TAKEAWAY ? (e == null ? void 0 : e.service.design.images.takeAway) || "https://static.cheerfy.com/integration/images/kiosk/takeaway.png" : (e == null ? void 0 : e.service.design.images.dineIn) || "https://static.cheerfy.com/integration/images/kiosk/dinein.png", s = e == null ? void 0 : e.service.text[m], o = a === r.TAKEAWAY ? (s == null ? void 0 : s.service_take_away) || c("kioskLanding.service.takeaway") : (s == null ? void 0 : s.service_dine_in) || c("kioskLanding.service.dineIn");
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      "data-testid": "kiosk-service",
      className: i.service,
      style: {
        "--background": (e == null ? void 0 : e.common.design.colors.secondaryButtonBackground) || "#F5F5F5",
        "--color": (e == null ? void 0 : e.common.design.colors.secondaryButtonText) || "#000000"
      }
    },
    /* @__PURE__ */ t.createElement("div", { className: i.title }, o),
    /* @__PURE__ */ t.createElement(
      "img",
      {
        className: i.image,
        alt: "service",
        src: n
      }
    )
  );
}
export {
  A as KioskService
};
//# sourceMappingURL=KioskService.js.map
